/**
 * Утилита для определения WebKit-браузеров
 * Поддерживает принудительное включение через localStorage для тестирования на Windows
 */

/**
 * Определяет, является ли браузер WebKit-движком
 * 
 * @returns true, если браузер использует WebKit (Safari, старые версии Chrome и т.д.)
 * 
 * @example
 * ```typescript
 * if (isWebKit()) {
 *   // Использовать WebKit-специфичную реализацию
 * }
 * ```
 */
export function isWebKit(): boolean {
    if (typeof window === 'undefined') {
        return false
    }

    // Принудительный режим для тестирования на Windows (только в development)
    if (process.env.NODE_ENV === 'development') {
        const forceWebKit = localStorage.getItem('force-webkit')
        if (forceWebKit === 'true') {
            return true
        }
    }

    // Проверка через userAgent
    // WebKit есть только в Safari (не в Chrome/Edge, которые используют Blink)
    // Chrome и Edge имеют "webkit" в userAgent, но это Blink, не WebKit
    const userAgent = navigator.userAgent.toLowerCase()
    
    // Определяем Safari: есть "safari", но нет "chrome" и "edge" и нет "crios" (Chrome iOS)
    const isSafari = 
        /safari/i.test(userAgent) && 
        !/chrome/i.test(userAgent) && 
        !/edge/i.test(userAgent) &&
        !/crios/i.test(userAgent) &&
        !/fxios/i.test(userAgent) // Firefox iOS тоже не Safari
    
    // НЕ используем CSS feature detection, так как Chrome/Edge тоже поддерживают -webkit-appearance
    // Это legacy префикс, который поддерживается везде для совместимости

    return isSafari
}
